import { useEffect } from 'react';

export const useWatchHeaderHeight = () => {
  useEffect(() => {
    let rafId: number;
    let observer: ResizeObserver;

    const waitForHeader = () => {
      const el = document.getElementById('mgk-webapp-header');
      if (el) {
        observer = new ResizeObserver(() => {
          const height = el.getBoundingClientRect().height;
          document.documentElement.style.setProperty(
            '--header-height',
            `${height}px`
          );
        });
        observer.observe(el);
      } else {
        rafId = requestAnimationFrame(waitForHeader);
      }
    };

    waitForHeader();

    return () => {
      cancelAnimationFrame(rafId);
      observer?.disconnect();
    };
  }, []);
};
